import React = require("react");
import Slider from "react-slick";
import { JumboKiosk } from "../../Kiosk/JumboKiosk";
import { Link } from "../../library/link";
import { Loader } from "../../loader";
import { scrollAdviceIntoView } from "../Advice/Advice";
import { InspirationBaseSelector, inspirationLabelsKiosk } from "../Shared/InspirationBaseSelector";
import { jumboText } from "../Shared/InspirationUtils";
import { MoodBasedInspirationLayoutProps } from "./MoodBasedInspirationState";

export const MoodBasedInspirationLayoutKiosk = (props: MoodBasedInspirationLayoutProps) => {
  const { moodGroups, pushDataLayer, routePath } = props
  let timeout;

  const handleInit = () => {
    const sliderElement = document.querySelectorAll(".slick-slider")?.[0]
    if (sliderElement) sliderElement.classList.add('interaction-active')
  }

  const handleBeforeChange = () => {
    const sliderElement = document.querySelectorAll(".slick-slider")?.[0]
    if (sliderElement) {
      sliderElement.classList.remove("interaction-active")
      clearTimeout(timeout)
    }

    timeout = setTimeout(() =>
      sliderElement && sliderElement.classList.add("interaction-active"), 5000)
  }

  const handleAfterChange = () => {
    const sliderElement = document.querySelectorAll(".slick-slider")?.[0]
    const slide = sliderElement.querySelector('.slick-current:first-child');
    slide ? sliderElement?.classList.remove('highlighted') : sliderElement?.classList.add('highlighted')
  }

  return (
    <div className="inspiration-page ip ip--kiosk ip--mood-based-inspiration" key="MoodBasedInspirationLayout">
      <JumboKiosk {...jumboText.mood} size="large" />

      <div className={"ip__content"}>
        {moodGroups.kind != 'loaded' ? <Loader /> :
          <div className="layout">
            <div className="layout__content">
              <div className="layout__group group__list">
                <div className="group__list-inner">
                  {moodGroups.value.map(moodGroup => (
                    <div className="group__list-item list-item">
                      <div className="list-item__title title--m">{moodGroup.id}</div>
                      <div className="list-item__content">
                        <div className="list-item__group list-item__group-slider">
                          <Slider {... {
                            accessibility: true,
                            infinite: false,
                            variableWidth: true,
                            speed: 500,
                            swipeToSlide: true,
                            slidesToShow: 4,
                            swipe: true,
                            beforeChange: handleBeforeChange,
                            afterChange: handleAfterChange,
                            onInit: handleInit
                          }}>
                            {moodGroup.moods.map((mood) =>
                              <Link
                                key={`mood-${mood}`}
                                className="slider__item-link"
                                handle={() => {
                                  pushDataLayer(moodGroup.id, mood.mood);
                                  scrollAdviceIntoView();
                                }}
                                url={`/${routePath}/stemming/${mood.mood}`}
                              >
                                <span className="slider__name">{mood.mood}</span>
                                <div className="slider__visual">
                                  <div className="slider__visual-visuals">
                                    {mood.covers.length > 0 ?
                                      mood.covers.map((x) => <img className="slider__image" src={`${x ? x : "/book-foto.png"}`} width="105" height="150" alt={"foto van de boek"} />) :
                                      <>
                                        <img className="slider__image" src="/book-foto.png" width="105" height="150" alt={"foto van de boek"} />
                                        <img className="slider__image" src="/book-foto.png" width="105" height="150" alt={"foto van de boek"} />
                                        <img className="slider__image" src="/book-foto.png" width="105" height="150" alt={"foto van de boek"} />
                                        <img className="slider__image" src="/book-foto.png" width="105" height="150" alt={"foto van de boek"} />
                                      </>
                                    }
                                  </div>
                                </div>
                              </Link>
                            )}
                          </Slider>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        }
      </div>
      <InspirationBaseSelector activeBase="mood" routePath={routePath} labels={inspirationLabelsKiosk} />
    </div>)
}
